import {
  Avatar,
  Box,
  Divider,
  Grid2 as Grid,
  ListItem,
  ListItemButton,
  Typography
} from '@mui/material'
import React from 'react'
import InputBase from 'design-system/input/base'
import VirtualizedList from 'components/VirtualScroll'
import { Outlet } from 'react-router-dom'
import { ListChildComponentProps } from 'react-window'
import useChat from './useChat'
import BadgeChat from 'components/Badge/Chat'

const ChatPage: React.FC = () => {
  const { chats, setFilter, openChat, pathLeaf, getLastMessage, getCount } =
    useChat()

  return (
    <Grid
      sx={{
        flexGrow: 1
      }}
      container
    >
      <Grid
        size={4}
        sx={{
          flexGrow: 1,
          backgroundColor: 'background.default'
        }}
      >
        <Box
          sx={{
            paddingBottom: '8px',
            paddingTop: '4px',
            paddingX: '8px',
            display: 'flex',
            borderRadius: '0px'
          }}
        >
          <InputBase
            sx={{ ml: 1, flex: 1 }}
            placeholder='Pesquisar...'
            onChange={event => setFilter(event.target.value.trim())}
          />
        </Box>
        <Divider />
        <VirtualizedList itemSize={70} itemCount={chats.length}>
          {(props: ListChildComponentProps) => {
            const { index, style } = props

            const currentChat = chats[index]

            const fullName = currentChat.fullName

            const lastMessage = getLastMessage(currentChat.chat_id)

            const isSelected = pathLeaf == currentChat.chat_id

            return (
              <ListItem
                style={{
                  ...style
                }}
                sx={{
                  backgroundColor: isSelected
                    ? 'action.selected'
                    : 'inherit'
                }}
                key={index}
                component='div'
                disablePadding
                onClick={() => openChat(currentChat)}
              >
                <ListItemButton
                  disabled={isSelected}
                  sx={{
                    opacity: currentChat.requested_deletion
                      ? '0.5'
                      : isSelected
                        ? '1!important'
                        : 'inherit'
                  }}
                >
                  <BadgeChat
                    badgeContent={getCount(currentChat.chat_id)}
                    color='error'
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%'
                      }}
                    >
                      <Avatar
                        src={currentChat.image}
                        alt={fullName}
                        sx={{
                          width: 48,
                          height: 48,
                          marginRight: '16px'
                        }}
                      />
                      <Box
                        textAlign='left'
                        display={'flex'}
                        flexDirection={'column'}
                        sx={{
                          width: 'calc(100% - 64px)'
                        }}
                      >
                        <Typography
                          variant='body1'
                          noWrap
                          overflow={'hidden'}
                          textOverflow={'ellipsis'}
                        >
                          {fullName}
                        </Typography>
                        <Typography
                          variant='body2'
                          noWrap
                          overflow={'hidden'}
                          textOverflow={'ellipsis'}
                          sx={{
                            color: 'text.secondary'
                          }}
                        >
                          {lastMessage}
                        </Typography>
                      </Box>
                    </Box>
                  </BadgeChat>
                </ListItemButton>
              </ListItem>
            )
          }}
        </VirtualizedList>
      </Grid>

      <Divider />
      <Grid
        size={8}
        sx={{
          flexGrow: 1
        }}
      >
        <Outlet></Outlet>
      </Grid>
    </Grid>
  )
}

export default ChatPage
